module.exports = __webpack_public_path__ + "static/img/product_helmet.b1dcf3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_helmet.jpg
// module id = 2foj
// module chunks = 0